module.exports = __webpack_public_path__ + "img/factory-cnc.932af303.jpg";